<template>
  <div class="card upload-csv">
    <h2 class="title is-size-6" style="display: flex; justify-content: center">Upload Invoice Template</h2>
    
    <form v-if="!responseReceived" @submit.prevent="uploadCSV">
      <!-- Parser selector -->
      <div class="field" style="margin-bottom: 1rem; display: flex; justify-content: center;">
        <div class="control">
          <div class="select">
            <select v-model="parser" required>
              <option disabled value="">Select parser</option>
              <option value="financeone">F1</option>
              <option value="quantum">QUANTUM</option>
              <option value="elms">ELMS</option>
              <option value="azentio">AZENTIO</option>
            </select>
          </div>
        </div>
      </div>
      <div class="file has-name is-boxed" style="display: flex; justify-content: center;">
        <label class="file-label">
          <input class="file-input" type="file" @change="handleFileUpload" ref="file">
          <span class="file-cta">
            <span class="file-icon">
              <i class="fas fa-upload"></i>
            </span>
            <span class="file-label">Choose a file…</span>
          </span>
          <span class="file-name">{{ fileName }}</span>
        </label>
      </div>
      <div style="display: flex; justify-content: center;">
        <button class="button is-primary is-fullwidth" type="submit" :disabled="!file || !parser">Upload</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'UploadCSV',
  data() {
    return {
      file: null,
      fileName: '',
      parser: '',
    };
  },
  methods: {
    handleFileUpload(event) {
      this.file = event.target.files[0];
      this.fileName = this.file.name;
    },
    async uploadCSV() {
      if (!this.file) return;

      this.$emit('loading', true); // Notify parent loading started

      const formData = new FormData();
      formData.append('file', this.file);
      formData.append('created_by', localStorage.getItem('userid'));

      const authToken = localStorage.getItem('token');

      try {
        const response = await axios.post('/api/v1/integration/submit-csv/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': authToken ? `Token ${authToken}` : process.env.VUE_APP_API_KEY,
            'source': 'UI',
            'parser': this.parser,
          }
        });

        const dataString = JSON.stringify(response.data, null, 2);
        this.$emit('response', dataString); // Emit response to parent
      } catch (error) {
        // console.error('Error uploading file:', error);
        const errorMessage = error.response ? JSON.stringify(error.response.data, null, 2) : 'An error occurred';
        this.$emit('response', errorMessage);
      } finally {
        this.$emit('loading', false); // Notify parent loading is done
      }
    }
  }
}
</script>
